module.exports = __webpack_public_path__ + "img/slt.c23a1f87.png";